import React from "react";
import { Card } from "react-bootstrap";
import "./css/timelineview.css"; // Vamos criar este CSS a seguir

const TimelineView = ({ rules = [] }) => {
  // Ordenar regras: primeiro as "before", depois as "after"
  const sortedRules = [...rules].sort((a, b) => {
    // Primeiro critério: direction (before vem antes de after)
    if (a.direction !== b.direction) {
      return a.direction === "before" ? -1 : 1;
    }

    // Segundo critério: para 'before', valores maiores vêm primeiro
    if (a.direction === "before") {
      return getMinutes(b) - getMinutes(a);
    }

    // Para 'after', valores menores vêm primeiro
    return getMinutes(a) - getMinutes(b);
  });

  // Função para converter a regra em minutos
  function getMinutes(rule) {
    const { time_value, time_unit } = rule;
    switch (time_unit) {
      case "minutes":
        return time_value;
      case "hours":
        return time_value * 60;
      case "days":
        return time_value * 24 * 60;
      case "weeks":
        return time_value * 7 * 24 * 60;
      default:
        return time_value;
    }
  }

  // Função para obter o tipo de mensagem em formato legível
  function getMessageType(action) {
    const types = {
      confirmation_message: "Confirmação",
      tips_message: "Dicas",
      feedback: "Feedback",
      reminder_message: "Lembrete",
      generic: "Genérico",
    };
    return types[action] || action;
  }

  // Função para formatar o tempo
  function formatTime(rule) {
    const { time_value, time_unit, direction } = rule;
    const units = {
      minutes: time_value === 1 ? "minuto" : "minutos",
      hours: time_value === 1 ? "hora" : "horas",
      days: time_value === 1 ? "dia" : "dias",
      weeks: time_value === 1 ? "semana" : "semanas",
    };

    return `${time_value} ${units[time_unit]} ${
      direction === "before" ? "antes" : "depois"
    }`;
  }

  // Função para obter a cor baseada no tipo de mensagem
  function getColor(action) {
    const colors = {
      confirmation_message: "#2ecc71", // verde
      tips_message: "#3498db", // azul
      feedback: "#9b59b6", // roxo
      reminder_message: "#f39c12", // laranja
      generic: "#7f8c8d", // cinza
    };
    return colors[action] || "#7f8c8d";
  }

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">Linha do Tempo das Automações</h5>
      </Card.Header>
      <Card.Body>
        <div className="timeline-container">
          <div className="timeline-line"></div>
          <div className="timeline-event timeline-event-center">
            <div className="timeline-event-dot timeline-event-dot-center"></div>
            <div className="timeline-event-content timeline-event-content-center text-center">
              Evento Principal (Agendamento)
            </div>
          </div>

          {sortedRules.map((rule) => (
            <div
              key={rule.id}
              className={`timeline-event ${
                rule.direction === "before"
                  ? "timeline-event-before"
                  : "timeline-event-after"
              } ${!rule.active ? "timeline-event-inactive" : ""}`}
              style={{
                // Calcular a posição com base no tempo (apenas representação visual)
                [rule.direction === "before" ? "right" : "left"]: `calc(50% + ${
                  // Fórmula para espaçamento proporcional ao logaritmo do tempo
                  Math.min(Math.log(getMinutes(rule)) * 15, 300)
                }px)`,
              }}
            >
              <div
                className="timeline-event-dot"
                style={{
                  backgroundColor: rule.active
                    ? getColor(rule.template_action)
                    : "#ccc",
                }}
              ></div>
              <div className="timeline-event-content">
                <span className="timeline-event-title">
                  {getMessageType(rule.template_action)}
                </span>
                <span className="timeline-event-time">{formatTime(rule)}</span>
                {rule.reference && (
                  <span className="timeline-event-time">
                    {rule.reference === "appointment_start"
                      ? "Início do agendamento"
                      : "Criação do agendamento"}
                  </span>
                )}
                {rule.template_name && (
                  <span className="timeline-event-template">
                    {rule.template_name}
                  </span>
                )}

                {!rule.active && (
                  <span className="timeline-event-inactive-badge">Inativo</span>
                )}
              </div>
            </div>
          ))}
        </div>

        {rules.length === 0 && (
          <div className="text-center text-muted p-3">
            Nenhuma regra de automação configurada.
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default TimelineView;
